module.exports = __webpack_public_path__ + "img/rating-4.749ec234.png";